var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimerClock(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "system / clock"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector 92 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.03125 4.6875L7.96875 4.6875L7.96875 7.30584L9.70646 9.04354L9.04354 9.70646L7.03125 7.69416L7.03125 4.6875Z",
    fill: "#010314",
    fillOpacity: 0.6
  }), /*#__PURE__*/React.createElement("path", {
    id: "Ellipse 12 (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.5 12.1875C10.0888 12.1875 12.1875 10.0888 12.1875 7.5C12.1875 4.91117 10.0888 2.8125 7.5 2.8125C4.91117 2.8125 2.8125 4.91117 2.8125 7.5C2.8125 10.0888 4.91117 12.1875 7.5 12.1875ZM7.5 13.125C10.6066 13.125 13.125 10.6066 13.125 7.5C13.125 4.3934 10.6066 1.875 7.5 1.875C4.3934 1.875 1.875 4.3934 1.875 7.5C1.875 10.6066 4.3934 13.125 7.5 13.125Z",
    fill: "#010314",
    fillOpacity: 0.6
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimerClock);
export default __webpack_public_path__ + "static/media/timer-clock.9e24952cee06a6affb5801e1a8c1f829.svg";
export { ForwardRef as ReactComponent };